import { motion, AnimatePresence } from "framer-motion";
import StateCard from "../sharedUi/stateCard";
import { MdAddShoppingCart, MdPaid } from "react-icons/md";
import { BiCart } from "react-icons/bi";
import PendingActionsIcon from '@mui/icons-material/PendingActions';


export default function OrderCardsUi ({value}) {

    return(<>

        <div>
            <AnimatePresence>  
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                    className="grid grid-cols-1 sm:grid-cols-4 gap-6 py-1 overflow-hidden"
                >
                {[ 
                    {
                    title: "Paid",
                    value: value?.paid?.current_total,
                    percentage: value?.paid?.percentage_change,
                    direction : value?.paid?.direction,
                    subtitle: "This Month Analytics",
                    icon: <MdPaid className="text-white" size={18} />,
                    iconBg: "bg-green-700"
                    },
                    {
                    title: "Orders",
                    value: value?.count_orders,
                    subtitle: "This Month Analytics",
                    icon: <BiCart className="text-white" size={18} />,
                    iconBg: "bg-purple-700"
                    },
                    {
                    title: "Pending Orders",
                    value: value?.count_pending_orders,
                    subtitle: "This Moment Analytics",
                    icon: <PendingActionsIcon className="text-white" fontSize='medium' />,
                    mui: true,
                    iconBg: "bg-blue-700"
                    },
                    {
                    title: "New Orders",
                    value: value?.new_orders?.current_total,
                    percentage: value?.new_orders?.percentage_change,
                    direction : value?.new_orders?.direction,
                    subtitle: "This Moth Analytics",
                    icon: <MdAddShoppingCart className="text-white" size={18} />,
                    iconBg: "bg-green-700"
                    },
                ].map((card, idx) => (
                    <motion.div
                    key={idx}
                    initial={{ rotateY: 90, opacity: 0 }}
                    animate={{ rotateY: 0, opacity: 1 }}
                    exit={{ rotateY: 90, opacity: 0 }}
                    transition={{ duration: 0.6, ease: "easeInOut", delay: idx * 0.1 }}
                    className="w-full"
                    style={{ transformStyle: "preserve-3d" }}
                    >
                    <StateCard {...card} />
                    </motion.div>
                ))}
                </motion.div>
            </AnimatePresence>
        </div>
    
    </>);
};